module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_4_main-d87b544d9b39498e5020c89c3e9b6ce6.png";